export default __webpack_public_path__ + "static/media/Cloudxier-logofull-colored-05.eb3f9428.png";